import React from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { IconRaiseHand } from '../../../base/icons/svg';
import BaseIndicator from '../../../base/react/components/web/BaseIndicator';
import { getCurrentLayout } from "../../../video-layout/functions.any";
import { LAYOUTS } from "../../../video-layout/constants";
const useStyles = makeStyles()(theme => {
    return {
        RaisedHandIndicatorMobile: {
            backgroundColor: 'rgba(255, 214, 56, 1)',
            padding: '4px',
            zIndex: 3,
            display: 'inline-block',
            borderRadius: '6px',
            boxSizing: 'border-box',
        },
        invisible: {
            opacity: 0,
            pointerEvents: 'none',
        },
    };
});
/**
 * Thumbnail badge showing that the participant would like to speak.
 *
 * @returns {ReactElement}
 */
const RaisedHandIndicatorMobile = ({ iconSize, tooltipPosition }) => {
    const raisedHandsCount = useSelector((state) => (state['features/base/participants'].raisedHandsQueue || []).length);
    const _raisedHand = raisedHandsCount > 0;
    const currentLayout = useSelector((state) => getCurrentLayout(state));
    const { classes: styles, cx } = useStyles();
    if (!_raisedHand || currentLayout !== LAYOUTS.HORIZONTAL_FILMSTRIP_VIEW) {
        return (React.createElement("div", { className: cx(styles.RaisedHandIndicatorMobile, styles.invisible) },
            React.createElement("div", { style: {
                    width: iconSize,
                    height: iconSize,
                } })));
    }
    return (React.createElement("div", { className: cx(styles.RaisedHandIndicatorMobile) },
        React.createElement(BaseIndicator, { icon: IconRaiseHand, iconColor: 'rgba(0, 0, 0, 1)', iconSize: `${iconSize}px`, tooltipKey: 'raisedHand', tooltipPosition: tooltipPosition })));
};
export default RaisedHandIndicatorMobile;
